<template>
<main>
  <div class="contact padded">
    <section id="contact-content">
      <header class="hidden section-title">
        <h1>{{contact.title}}</h1>
      </header>
      <div class='content--text big-text' v-html="contact.mainText"></div>
      <div class='content--text address' v-html="contact.address"></div>
       <template v-if="contact.socials">
        <ul class="socials" v-for="(social, index) in contact.socials" :key="'social'+index">
          <li><a :href="social.facebook" alt="facebook" target="_blank">fb</a></li>
          <li><a :href="social.instagram" alt="instagram" target="_blank">in</a></li>
          <li><a :href="social.twitter" alt="twitter" target="_blank">tw</a></li>
        </ul>
      </template>
    </section>
  </div>
</main>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'contact',
  metaInfo() {
    return {
      title: '– Contact',
      meta: [{
        description: this.contact.text
      }]
    }
  },
  computed: mapState(['contact']),
  data() {
    return {
    }
  },
  methods:{
    emitToApp(){
      this.$emit('mountedPage');
    }
  },
  created() {
    this.$store.dispatch('loadContact');
  },
  mounted(){
    let self = this;
    setTimeout(function(){
      self.emitToApp();
    },500)
  }
  
}
</script>

<style lang="scss" scoped>
#app .grid.contact{
  grid-gap: 1rem;
  max-width:1600px;
}
main{
  min-height: calc(100vh - 126px);
  background: var(--lighter--bgcolor);
  > div > section{
    padding:1.5rem;
    @media screen and (min-width: 769px){
      padding:3rem;
    }
  }
  .big-text{
    font-size: 1.3rem;
    line-height: 2.4rem;
    margin-bottom:6.666rem;
    font-family: 'surtlight_exp.';
    letter-spacing: 1px;
    @media screen and (min-width: 769px){
      font-size: 3.6rem;
      line-height:4.3333rem;
      letter-spacing: 3px;
    }
  }
  .address{
    font-family: 'surtlight_exp.';
    margin-bottom:3.466rem;
    @media screen and (min-width: 769px){
      font-size:1.33rem;
      line-height:2.066rem;
    }
  }

  ul.socials li{
    display:inline-block;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background-color: var(--fontcolor);
    text-align: center;
    font-size: 1rem;
    line-height: 1rem;
    padding: 0;
    vertical-align: middle;
    margin-right:.9rem;
    position:relative;
    @include transition(background-color .5s ease);
    &:hover{
      background-color: var(--hover);
    }
    a{
      color:var(--bgcolor);
      padding:0 1rem;
      position: absolute;
      top: 50%;
      left:50%;
      @include transform(translate(-50%, -50%));
    }
  }
  #contact-content{
    max-width:1400px;
    margin:auto;
    @media screen and (min-width: 768px){
      padding: 5rem 6.5rem;
    }
    header{
      margin-bottom:2rem;
      padding:0 0 2rem 0;
    }
    .content--form{
      margin-top:8rem;
      p.infos{
        font-size: 1.2rem;
        line-height: 1.6rem;
        max-width: 300px;
        margin-bottom:2rem;
      }
    }
    .input--infos{
      display: block;
      margin: .5rem 0;
      color: #F21628;
    }
  }
} 
</style>
